import React, { createContext, useReducer, useContext, useEffect } from 'react'
import axios from 'axios'
import { AuthContext } from './signin/AuthContext'
import { useGrowSetup } from '../GrowSetupContext';

// Initialer Konfig- und Change-State
const initialConfig = {
  temperatur_tag: 22,
  temperatur_nacht: 20,
  luftfeuchte_tag: 55,
  luftfeuchte_nacht: 60,
  abluft_max_intensity: 50,
  abweichung_luftfeuchte: 5,
  max_light: 50,
  dauer: 30,
  sun_rise: '06:00',
  sun_set: '18:00',
  vpd_phase: 'veg',
}

// Wir erweitern den State um trackedChanges
const initialState = {
  config: initialConfig,
  changes: {}, // key: fieldName, value: newValue
}

// Reducer
function configReducer(state, action) {
  switch (action.type) {
    case 'SET_FIELD': {
      const { field, value } = action
      return {
        config: { ...state.config, [field]: value },
        changes: { ...state.changes, [field]: value },
      }
    }
    case 'RESET':
      return { config: action.payload, changes: {} }
    case 'CLEAR_CHANGES':
      return { ...state, changes: {} }
    default:
      return state
  }
}

// Context
const ConfigContext = createContext({
  state: initialConfig,
  dispatch: () => {},
  config: initialConfig,
  changes: {},
  loadConfig: async () => {},
  saveConfig: async () => {},
  setField: () => {},
})

export function ConfigProvider({ children }) {
  const { token } = useContext(AuthContext)
  const [state, dispatch] = useReducer(configReducer, initialState)
  const { config, changes } = state
  const { grow_setup, setGrowSetup } = useGrowSetup()

  // Lädt Config vom Server
  const loadConfig = async () => {
    if (!grow_setup || !token) return
    try {
      const resp = await axios.get(
        `/get_sys_config_grow_setup/${grow_setup}`,
        { headers: { Authorization: 'Bearer ' + token } }
      )
      dispatch({ type: 'RESET', payload: resp.data })
    } catch (err) {
      console.error('Fehler beim Laden der Config:', err)
    }
  }

  // Speichert aktuellen Config-State auf dem Server
  const saveConfig = async () => {
    if (!grow_setup || !token) return
    try {
      await axios.post(
        `/config_save/${grow_setup}&0`,
        { data: config },
        { headers: { Authorization: 'Bearer ' + token } }
      )
      // Nach speicher clear changes
      dispatch({ type: 'CLEAR_CHANGES' })
    } catch (err) {
      console.error('Fehler beim Speichern der Config:', err)
    }
  }

  // Automatischer Load, wenn Token oder grow_setup sich ändern
  useEffect(() => {
    loadConfig()
  }, [token, grow_setup])

  return (
    <ConfigContext.Provider
      value={{
        state,
        dispatch,
        config,
        changes,
        loadConfig,
        saveConfig,
        setField: (field, value) => dispatch({ type: 'SET_FIELD', field, value }),
      }}
    >
      {children}
    </ConfigContext.Provider>
  )
}

export function useConfig() {
  return useContext(ConfigContext)
}
